import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import api from "../services/api";
import StorageService from "../services/StorageService";

function isLogisticsServiceUser(user) {
  if (!user) return false;
  const serviceRoleId = user.service_role_id;
  return serviceRoleId != null && String(serviceRoleId).trim() !== "";
}

/**
 * Blocks logistics provider dashboard routes until the full logistics profile is saved.
 */
export default function LogisticsProviderProfileGate({ children }) {
  const location = useLocation();
  const [state, setState] = useState({ loading: true, allow: true });

  useEffect(() => {
    const user = StorageService.getUser();
    if (!isLogisticsServiceUser(user)) {
      setState({ loading: false, allow: true });
      return;
    }

    let cancelled = false;
    (async () => {
      try {
        const res = await api.get("/company/logistics/my-profile");
        const data = res?.data?.data ?? res?.data ?? null;
        const isComplete = Boolean(data?.isComplete);
        if (!cancelled) {
          setState({ loading: false, allow: isComplete });
          if (!isComplete && !location.pathname.startsWith("/logistics-profile")) {
            toast.info("Please complete your Logistics Provider Profile before accessing the system.", {
              toastId: "lp-profile-gate",
            });
          }
        }
      } catch {
        if (!cancelled) {
          setState({ loading: false, allow: false });
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [location.pathname]);

  if (state.loading) {
    return <div className="p-4 text-center text-muted">Loading…</div>;
  }

  if (!state.allow && !location.pathname.startsWith("/logistics-profile")) {
    return <Navigate to="/logistics-profile/edit" replace />;
  }

  return children;
}
